import type { AcledPost } from '../types/acled'

/** News-Regel: maximal 3 Tage zurück (heute-basiert). */
export const NEWS_DAYS = 3

export const newsCutoff = () => {
  const cutoff = new Date()
  cutoff.setHours(0, 0, 0, 0)
  cutoff.setDate(cutoff.getDate() - (NEWS_DAYS - 1))
  return cutoff.getTime()
}

/** ACLED-Posts der letzten NEWS_DAYS Tage — einheitlich für Feed, Karte und Foren. */
export const acledPosts = (): AcledPost[] => {
  const all = window.ACLED?.posts ?? []
  const cutoff = newsCutoff()
  return all.filter((p) => new Date(`${p.date}T00:00:00`).getTime() >= cutoff)
}

export const acledWindowLabel = () => window.ACLED?.dates ?? '—'
export const acledGenerated = () => window.ACLED?.generated ?? '—'
